import { FC, useState } from "react";
import {
  TICKET_BODY_MAX_LENGTH,
  getTicketErrorMessage,
} from "entities/support-ticket";
import { FormTextarea, formStyles } from "shared/ui";
import { useReplyTicketMutation } from "../api/replyTicketApi";

import styles from "./ReplyTicketForm.module.css";

interface Props {
  ticketId: number;
}

export const ReplyTicketForm: FC<Props> = ({ ticketId }) => {
  const [body, setBody] = useState("");
  const [replyTicket, { isLoading, error, reset }] = useReplyTicketMutation();
  const trimmedBody = body.trim();

  const handleChange = (value: string) => {
    setBody(value);
    reset();
  };

  const handleSubmit = async () => {
    const result = await replyTicket({ ticketId, body: trimmedBody });
    if (result.data) setBody("");
  };

  return (
    <form
      className={styles.form}
      noValidate
      onSubmit={(event) => {
        event.preventDefault();
        handleSubmit();
      }}
    >
      <FormTextarea
        placeholder="Write a reply..."
        rows={3}
        maxLength={TICKET_BODY_MAX_LENGTH}
        value={body}
        error={getTicketErrorMessage(error)}
        onValueChange={handleChange}
        disabled={isLoading}
      />
      <button
        type="submit"
        className={formStyles.submitButton}
        disabled={isLoading || !trimmedBody}
      >
        {isLoading ? "Sending..." : "Send"}
      </button>
    </form>
  );
};
